<template>
  <div class="contentSet">
    <div class="contentSetTitle">发送邮件</div>
    <el-row :gutter="12" type="flex">
      <el-col >
        <el-form class="contentSetForm" :model="contentSetForm" :rules="contentSetRules" ref="contentSetForm" >
          <!-- 发件人 -->
          <el-form-item class="borderB" :label="'发件人'" label-width="80px"  prop="">
            <div class="borderBdiv">
            {{this.$store.state.supplierState.sendMail}}
          </div>
          </el-form-item>
          <!-- 收件人 -->
          <el-form-item class="borderB" :label="'收件人'" label-width="80px"  prop="contactIds">
            <div class="recipientTitle">
              <div class="recipientInput">
                <!-- <el-input placeholder="收件人" clearable v-model="contentSetForm.title" :maxlength="500" size="small" @blur="contentSetFormData('title')"></el-input> -->
                <el-tag
                  class="tagList"
                  type="info"
                  v-for="tag in contactIds"
                  :key="tag.id"
                  closable
                  @close="handleClosetag(tag)"
                >
                {{ tag.contactName }} &lt;{{ tag.email }}&gt;
                </el-tag>
              </div>
              <div class="recipientList" @click="recipientDialog">
                选择收件人
              </div>
            </div>
          </el-form-item>
          <!-- 营销目的 -->
          <el-form-item class="borderB" :label="'营销目的'" label-width="80px"  prop="name">
            <el-autocomplete
              class="inline-input"
              v-model="contentSetForm.name"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              @select="handleSelect"
              clearable
              :maxlength="500"
              size="small" @blur="contentSetFormData('name')"
            ></el-autocomplete>
            <!-- <el-input placeholder="输入文字" v-model.trim="contentSetForm.name" size="small" @blur="contentSetFormData('name')"></el-input> -->
          </el-form-item>
          <!-- 邮件主题 -->
          <el-form-item class="borderB" :label="'邮件主题'" label-width="80px" prop="title">
            <div class="emailTitle">
              <div class="emailTitleInput">
                <el-input placeholder="输入英文邮件主题" clearable v-model="contentSetForm.title" :maxlength="500" size="small" @blur="contentSetFormData('title')"></el-input>
              </div>
              <div class="emailTitleAI" @click="AIbtnShowFun('second')">
                想不出？小智帮你
              </div>
            </div>
          </el-form-item>
          <!-- 邮件称谓 -->
          <el-form-item :label="'邮件称谓'" label-width="80px" >
            <!-- 根据邮件语言的选择而联动显示。当邮件语言为英语时，则显示英文Dear称谓；当邮件语言为中文时，则显示中文称谓（亲爱的${UserName}） -->
            <el-checkbox v-model="contentSetForm.showUserName" size="small" @change="contentSetFormData('showUserName')">{{contentSetForm.language==1?'Dear ${UserName}':'亲爱的${UserName}'}}</el-checkbox>
            <div class="title-ps">注意：正文内容，在下方填充即可。系统会自动加上勾选的邮件签名 ，勾选称谓。如果去除称谓勾选，则邮件内容不显示称谓。</div>
          </el-form-item>
          <!-- 邮件正文 -->
          <el-form-item :label="'邮件正文'" label-width="80px" prop="content">
            <!-- <el-input placeholder="输入文字" v-model="contentSetForm.content" size="small"></el-input> -->
            <tinyeditor
              :resize="true"
              :minHeight="500"
              :maxHeight="null"
              :content="content"
              :maxSize="20000"
              @geEditor="geEditor"
              :AIbtnShow="AIbtnShow"
              @AIbtnShowFun="AIbtnShowFun"
            />
          </el-form-item>
          <!-- 邮件附件 -->
          <el-form-item :label="'邮件附件'" label-width="80px" >
              <uploadLine
                :uploadHandling="uploadHandling"
                :acceptType="acceptType"
                :partsVersion="0"
                :fileListArr="attachmentVos"
                :paramsupload="paramsupload"
                :size="5"
                :maxFiles="'最多支持5个附件上传'"
                :flieSize="'大小不超过5M'"
                @changeFileList="changeFileList1"
                :totalNum="5"
                :tempUrlShow="tempUrlShow"
              />
          </el-form-item>
          <!-- 邮件签名 -->
          <el-form-item :label="'邮件签名'" label-width="80px" >
            <el-popover
              placement="bottom"
              :trigger="triggerType"
              popper-class="popoverSign"
              v-model="SignShowPopover"
              ref="elpopover"
              >
              <div class="signListdivAll">
                <div class="signListdiv"  v-for="(item,index) in SingListArr" :key="index">
                  <div class="itemSign" @click="changeSign(item)">{{item.name}}</div>
                  <!-- <div class="itemSign">签名1</div>
                  <div class="itemSign">签名1</div> -->
                </div>
                <div>
                  <el-button type="text" @click="createdSignDialog">+新建签名</el-button>
                </div>
              </div>
              <el-button slot="reference" @click="SignShowPopover=!SignShowPopover" class="addSignReference">增加签名</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="" label-width="80px" v-if="contentSetForm.signatureId!=''">
            <div class="SingContent"  v-html="SingContent"> </div>
          </el-form-item>
          <!-- 回复邮箱 -->
          <el-form-item label="回复邮箱" label-width="80px" prop="replyEmail" class="replyEmail">
            <el-input placeholder="输入文字" v-model="contentSetForm.replyEmail" size="small" @blur="contentSetFormData('replyEmail')"></el-input>
          </el-form-item>
          <!-- 发送时间 -->
          <el-form-item label="发送时间" label-width="80px" prop="sendModel" class="replyEmail">
            <el-radio-group v-model="contentSetForm.sendModel" size="small" @change="sendModelChange">
              <el-radio :label="1" >立即发送</el-radio>
              <el-radio :label="2" >定时发送</el-radio>
            </el-radio-group>
            <div v-if="contentSetForm.sendModel==2">
              <el-form :model="timezoneSetForm" :rules="timezoneSetRules" ref="timezoneSetForm" class="TimezoneSetForm">
                <el-form-item label="选择时区" label-width="100px" prop="scheduleSendTimezone" >  
                  <el-select v-model="timezoneSetForm.scheduleSendTimezone" 
                  placeholder="请选择"  collapse-tags  @change="scheduleSendTimezoneChange"  class="scheduleSendTimezone">
                    <el-option
                    v-for="item in timeDetail"
                    :key="item.id"
                    :label="item.label"
                    :value="item.codeVal"  >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="当地时间" label-width="100px" flexd prop="scheduleSendTimezoneTime" class="scheduleSendTimezoneTime"> 
                  <!-- 选择日期 -->
                  <el-date-picker v-model="dates" align="right" type="date" :placeholder="'选择日期'"
                    class="date" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" @change="datesBlur" >
                  </el-date-picker>
                  <!-- 选择时间 -->
                  <el-time-picker v-model="time" :placeholder="'选择时间'"  class="date datesTime"
                    format="HH:mm" value-format="HH:mm" :picker-options="pickerOptionsTime"
                    :disabled="timeDefault" @blur="datesTime" >
                  </el-time-picker>
                </el-form-item>
                <div v-if="timezoneSetForm.scheduleSendTimezoneTime">邮件将在(UTC+8:00)北京、香港、台湾时间：<span class="localtime">{{timeresY}}</span> 发送</div>
              </el-form>
            </div>
          </el-form-item>
          <!-- 退订链接 -->
          <el-form-item :label="'退订链接'" label-width="80px" >
            <div class="unsubscribe">为保证邮件触达率，已为您使用默认退订链接</div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <AIAbility ref="AIAbility" @AIdrawer="AIdrawer"  :sendEmailShow="false"/>
    <div>
      <el-dialog
        title="添加签名"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        custom-class="signDialog"
        >
        <div>
          <el-form :model="signForm" :rules="signcontentSetRules" class="signForm" ref="signForm">
            <el-form-item :label="'签名名称'" label-width="100px" prop="name" >
              <el-input placeholder="输入文字" v-model="signForm.name" size="small" maxlength="8" show-word-limit></el-input>
            </el-form-item>
            <el-form-item :label="'签名内容'" label-width="100px" prop="content" >
              <!-- <el-input placeholder="输入文字" v-model="signForm.content" size="small" maxlength="8"></el-input> -->
              <tinyeditor  
                :maxHeight="254"
                :content="signFormcontent"
                :maxSize="20000"
                @geEditor="signgeEditor"
              />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button v-no-more-click type="primary" @click="createdSign('0')" plain>保存并使用</el-button>
          <el-button v-no-more-click type="primary" @click="createdSign('1')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div>
      <allRecipientList ref="allRecipientListDialog" @determineSelect="determine" />
    </div>
  </div>
</template>
<script>
import tinyeditor from "@/components/tyniedor";
import uploadLine from "@/components/intellect-marketing/uploadLine"
import AIAbility from "@/components/intellect-marketing/mailDetail/AIAbility"
import {signatureList,signatureSave,sendEmailVerifyBulk,usersendEmailVerifyBulk} from "@/utils/api/edmSubject"
import allRecipientList from "@/components/customer-follow/allRecipientList"
import timeDetail from "@/assets/js/timeDetail.js"
import { dayjsFormat } from '@/utils/common.js'
import { handleFormatDate, handleFormatDateHHmmss } from "@/utils/handle.js";
import {
  customerSendEmailVerify
} from "@/utils/api/customerdetail";
import {
  userSendEmailVerify
} from "@/utils/api/customer";

// 
export default {
  components: {
    tinyeditor,uploadLine,AIAbility,allRecipientList
  },
  data(){
    
    var nameData = (rule, value, callback) => {
      if (value.trim()==''||value=='') {
        return callback(new Error('请输入营销目的'));
      } else {
        callback();
      }
    }

    var titleData = (rule, value, callback) => {
      if (value.trim()==''||value=='') {
        return callback(new Error('输入英文邮件主题'));
      } else {
        callback();
      }
    }

      var contentData = (rule, value, callback) => {
        if (this.contentSetForm.content.length <= 61) {
          return callback(new Error('请输入邮件正文'));
        } else {
          callback();
        }
      }
      var contentSing = (rule, value, callback) => {
        if (this.signForm.content.length <= 61) {
          return callback(new Error('请输入签名内容'));
        } else  {
          callback();
        }
      }
      var contactIdsChange=(rule, value, callback) => {
       
        if (this.contactIds.length == 0) {
          return callback(new Error('收件人不能为空'));
        } else  {
          callback();
        }
      }
    // 定时时间校验
    var checkTime = (rule, value, callback) => {
      if (this.contentSetForm.sendModel == 2) {
        if (
          this.dates == "" ||
          this.time == "" ||
          this.dates == null ||
          this.time == null||this.contentSetForm.scheduleSendTimezone==''
        ) {
          return callback(new Error('请选择当地时间'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 邮箱校验
    var checkEmail = (rule, value, callback) => {
      const reg =
        /^([a-zA-Z0-9_\-.]+)@(([a-zA-Z0-9-]+\.)+)([a-zA-Z]{2,10}|[0-9]{1,3})$/;
      if (value === "" || !value) {
        return callback(new Error('输入邮箱'));
      }
      else if (!reg.test(value)) {
        return callback(new Error('邮箱格式有误'));
      } else {
        callback();
      }
    };
    return{
      edm_purpose: [],
      content:'',//邮件富文本框
      signFormcontent:'',//签名富文本框
      AIbtnShow:true,
      contentSetForm: {
        name:'',//任务名称
        language:1,//语言 1=英文 2=中文
        title:'',//邮件标题
        showUserName:true,//邮件称谓 0=不显示 1=亲爱的xx
        content:'',//邮件正文
        signatureId:'',//邮件签名表id
        hashcodeList:[],//附件hashcode
        replyEmail:'',
        contactIds: [],
        scheduleSendTime:'',
        scheduleSendTimezone:'Asia/Shanghai',//时区
        scheduleSendTimezoneTime:"",//定时时区的时间
        sendModel:1,//发送模式 1=立即发送;2=定时发送
      },
      contentSetRules: {
        name: [
          { required: true, validator:nameData,  message: '请输入营销目的', trigger: 'blur' }
        ],
        language:[
          { required: true, message: '请选择邮件语言', trigger: 'change' }
        ],
        title: [
          { required: true, validator:titleData, message: '', trigger: 'blur' }
        ],
        content:[
          { required: true, validator: contentData, trigger: 'blur' }
        ],
        contactIds:[{ required: true,validator: contactIdsChange, trigger: 'change' }],
        replyEmail:[
          { required: true, validator: checkEmail, trigger: "blur" },
        ],
      },
      dialogVisible:false,
      signForm:{
        name:'',//签名名称
        content:'',//签名内容
        isDef:'',//是否默认 0:是 1:否
      },
      signcontentSetRules:{
        name: [
          { required: true, message: '请输入签名名称', trigger: 'blur' }
        ],
        content:[
          { required: true,  validator: contentSing,  trigger: 'blur' }
        ],
      },
      triggerType:'manual',
      SignShowPopover:false,
      SingListArr:[],//签名列表
      SingContent:'',//签名内容
      acceptType:".ppt,.pptx,.pdf,.png,.jpg,.jpeg",
      drawingVoList: [],
      paramsupload: {
        source: 91,
        sourceType: 91,
        isCreateThumbnail: false,
        project: 'haizol-seamark-web-online',
        modelType: 5,
        isCreateThumbnail: false,
        picSizeType: 1,
      },
      attachmentVos:[],
      uploadHandling:false,
      AIwritingShow:true,
      tempUrlShow:false,//下载附件是用临时还是正式,false:临时，true:正式
     // 时区处理
      dates:'',
      time:'',
      timeDetail:timeDetail,
      localtime:'',
      timeresY:'',
      scheduleSendTimezone:'',
      timeDefault: true,//日期时间的校验
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptionsTime: {
        selectableRange: "00:00:00 - 23:59:59",
      },
      contactIds:[],
      filterEmailSize:0,
      timezoneSetForm: {
        scheduleSendTimezone:'Asia/Shanghai',//时区
        scheduleSendTimezoneTime:"",//定时的时间
      },
      timezoneSetRules: {
        scheduleSendTimezone: [{ required: true,  message: '请选择时区', trigger: 'change' }],
        scheduleSendTimezoneTime: [{ required: true, validator: checkTime, trigger: "blur" }],
      },
      customerId:[],
      userId:[]
    }
  },
  mounted(){
    this.getSingList()
    this.contentSetForm.replyEmail=this.$store.state.supplierState.replyMail
    if(this.$route.query.customerId){
      // this.customerId=[]
      this.customerId=this.$route.query.customerId
      this.getCustomerSendEmailVerify()
    }
    if(this.$route.query.customerIds){
      // this.customerId=[]
      this.customerId=this.$route.query.customerIds
      this.getSendEmailVerifyBulk()
    }
    if(this.$route.query.userId){
      // this.userId=[]
      this.userId=this.$route.query.userId
      this.getUserSendEmailVerify()
    }
    if(this.$route.query.userIds){
      // this.userId=[]
      this.userId=this.$route.query.userIds
      this.getUsersendEmailVerifyBulk()
    }
  },
  methods:{
    // 单个获取客户发送邮件的数据
    getCustomerSendEmailVerify(){
      let params={
        id: this.customerId,
      }
      customerSendEmailVerify(params).then(res=>{
        if(res.rspResult.bizCode==200){
          // this.contentSetForm.contactIds=res.data.customerUserVos
          this.contactIds=res.data.customerUserVos
          this.contentSetForm.contactIds=[]
          this.contactIds.map(item=>{
            this.contentSetForm.contactIds.push(item.id)
          })
          this.filterEmailSize=res.data.filterEmailSize
          this.contentSetFormData('contactIds')
          if(this.filterEmailSize>0){
            this.$message({
              dangerouslyUseHTMLString: true,
              message: `<strong>为了保障您的使用体验，已为你过滤掉 <span style="color:#ffac2f"> ${this.filterEmailSize}</span> 个排除列表中的收件人</strong>`
            });
          }
        }
      })
    },
    // 批量获取客户发送邮件的数据
    getSendEmailVerifyBulk(){
      let params={
        uuid: this.customerId,
      }
      sendEmailVerifyBulk(params).then(res=>{
        if(res.rspResult.bizCode==200){
          // this.contentSetForm.contactIds=res.data.customerUserVos
          this.contactIds=res.data.customerUserVos
          this.contentSetForm.contactIds=[]
          this.contactIds.map(item=>{
            this.contentSetForm.contactIds.push(item.id)
          })
          this.filterEmailSize=res.data.filterEmailSize
          this.contentSetFormData('contactIds')
          if(this.filterEmailSize>0){
            this.$message({
              dangerouslyUseHTMLString: true,
              message: `<strong>为了保障您的使用体验，已为你过滤掉 <span style="color:#ffac2f"> ${this.filterEmailSize}</span> 个排除列表中的收件人</strong>`
            });
          }
        }
      })
    },
    // 单个获取联系人发送邮件的数据
    getUserSendEmailVerify(){
      let params={
        id:this.userId
      }
      userSendEmailVerify(params).then(res=>{
        if(res.rspResult.bizCode==200){
          this.contactIds=[]
          this.contactIds.push(res.data)
          this.contentSetForm.contactIds=[]
          this.contactIds.map(item=>{
            this.contentSetForm.contactIds.push(item.id)
          })
          // this.filterEmailSize=res.data.filterEmailSize
          this.contentSetFormData('contactIds')
          // if(this.filterEmailSize>0){
          //   this.$message({
          //     dangerouslyUseHTMLString: true,
          //     message: `<strong>为了保障您的使用体验，已为你过滤掉 <span style="color:#ffac2f"> ${this.filterEmailSize}</span> 个排除列表中的收件人</strong>`
          //   });
          // }
        }
      })
    },
    // 批量获取联系人发送邮件的数据
    getUsersendEmailVerifyBulk(){
      let params={
        uuid:this.userId
      }
      usersendEmailVerifyBulk(params).then(res=>{
        if(res.rspResult.bizCode==200){
          this.contactIds=[]
          this.contactIds=res.data.customerUserVos
          this.contentSetForm.contactIds=[]
          this.contactIds.map(item=>{
            this.contentSetForm.contactIds.push(item.id)
          })
          this.filterEmailSize=res.data.filterEmailSize
          this.contentSetFormData('contactIds')
          if(this.filterEmailSize>0){
            this.$message({
              dangerouslyUseHTMLString: true,
              message: `<strong>为了保障您的使用体验，已为你过滤掉 <span style="color:#ffac2f"> ${this.filterEmailSize}</span> 个排除列表中的收件人</strong>`
            });
          }
        }
      })
    },
    // 编辑时的传值
    contentSetData(formData){
      this.contentSetForm.name=formData.name
      // let optionsArr={
      //     value: formData.name,
      //     label: formData.name
      //   }
      // this.options.push(optionsArr)
      this.contentSetForm.language=formData.language
      this.contentSetForm.title=formData.title
      this.contentSetForm.showUserName=formData.showUserName==1?true:false
      this.contentSetForm.content=formData.content
      this.content=formData.content
      this.attachmentVos=[]
      let hashcodeList=[]
      if(formData.attachmentVos!=[]&&formData.attachmentVos!=null){
        this.attachmentVos=formData.attachmentVos
        formData.attachmentVos.map(item=>{
          hashcodeList.push(item.hashCode)
        })
      }
      if(this.attachmentVos.length>=5){
        this.uploadHandling=true
        this.contentSetForm.hashcodeList=this.attachmentVos
        this.tempUrlShow=true
      }else{
        this.uploadHandling=false
        this.contentSetForm.hashcodeList=hashcodeList
        this.tempUrlShow=false
      }
      this.contentSetForm.replyEmail=formData.replyEmail
      this.contentSetForm.sendModel=formData.sendModel
      this.contentSetForm.scheduleSendTimezone=formData.scheduleSendTimezone?formData.scheduleSendTimezone:'Asia/Shanghai'
      this.timezoneSetForm.scheduleSendTimezone=this.contentSetForm.scheduleSendTimezone
      this.contentSetForm.scheduleSendTimezoneTime=formData.scheduleSendTimezoneTime
      this.localtime=this.contentSetForm.scheduleSendTimezoneTime
      this.contentSetForm.scheduleSendTime=formData.scheduleSendTime
      this.determine(formData.customerUserVos)
      // this.contentSetForm.signatureId=formData.signatureId
      if(this.contentSetForm.sendModel==2&&this.contentSetForm.scheduleSendTimezoneTime!=null&&this.contentSetForm.scheduleSendTimezoneTime!=''){
        this.dates=handleFormatDate(this.contentSetForm.scheduleSendTimezoneTime)
        this.time = handleFormatDateHHmmss(this.contentSetForm.scheduleSendTimezoneTime);
        this.timeDefault = false;
      }
      this.sendModelChange()
      this.changeSign(formData.signatureVo)
      if(this.contentSetForm.sendModel==2&&this.contentSetForm.scheduleSendTimezoneTime!=null&&this.contentSetForm.scheduleSendTimezoneTime!=''){
        this.localtimeBlur(true)
      }
      this.contentSetFormData('tempUrlShow')

    },
    // 附件上传
    changeFileList1(arr, flag) {
      // const newArr = [];
      // arr.forEach((val, key) => {
      //   newArr.push(val.hashCode);
      // });  hashcode
      this.attachmentVos = arr;
      let hashcodeList=[]
      this.attachmentVos.map(item=>{
          hashcodeList.push(item.hashCode)
        })
      if(this.attachmentVos.length>=5){
        this.uploadHandling=true
        this.contentSetForm.hashcodeList=hashcodeList
        this.tempUrlShow=false
      }else{
        this.uploadHandling=false
         this.contentSetForm.hashcodeList=hashcodeList
      }
       this.contentSetFormData('hashcodeList')
       this.contentSetFormData('attachmentVos')
       this.contentSetFormData('tempUrlShow')
    },
    // 新建签名弹框
    createdSignDialog(){
      this.dialogVisible=true
    },
    // 选中签名
    changeSign(item){
      this.SignShowPopover=false
      // console.log(item)
      if(item!=null&&item.id!=-1){
        this.contentSetForm.signatureId=item.id
        this.SingContent=item.content
      }else{
        this.contentSetForm.signatureId=''
        this.SingContent=''
      }
      this.contentSetFormData('signatureId')
      if(this.contentSetForm.signatureId!=-1){
        this.contentSetFormData('SingContent')
      }
    },
    // 新建弹框
    handleClose() {
      this.dialogVisible=false
      this.SignShowPopover=false
      this.signForm.name=''
      this.signForm.content=''
    },
    // 保存新建签名
    async createdSign(type){
      if(type==0){
        this.contentSetForm.signatureId=''
      }
      new Promise((resolve, reject) => {
        this.$refs["signForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        })
      }).then((resolve)=>{
        if(resolve){
          this.signForm.isDef=type
          const res= signatureSave(this.signForm)
          this.handleClose()
          setTimeout(()=>{
            this.getSingList()
          },500)
        }
      })
    },
    //签名富文本框
    signgeEditor(val){
      // console.log(val)
     this.signForm.content = val === "<p><br></p>" ? "" : val;
     this.$refs["signForm"].validateField('content');
    },
    // 获取签名列表
    async getSingList(){
      const res=await signatureList()
      this.SingListArr=res.rspListData.list
      var temp = {};
      temp.name = '不显示签名';
      temp.id = "-1";
      temp.content = "";
      this.SingListArr.push(temp);
      this.SingListArr.map((item)=>{
        if(this.contentSetForm.signatureId==''&&item.isDef==0){
          // console.log(this.contentSetForm.signatureId+'========================')
          this.contentSetForm.signatureId=item.id
          this.SingContent=item.content
        }
      })
      this.contentSetFormData('signatureId')
      this.contentSetFormData('SingContent')
    },
    // 邮件富文本框
    geEditor(val) {
      // console.log(val)
      this.contentSetForm.content = val === "<p><br></p>" ? "" : val;
      // 单独校验一次
      this.$refs["contentSetForm"].validateField('content');
      this.contentSetFormData('content')
    },

    // 入参处理传入父组件
    //表单验证
    contentForm () {
      return new Promise((resolve, reject) => {
        this.$refs["contentSetForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        });
      })
    },
    // 定时时区表单验证
    timezoneForm(){
      let a= new Promise((resolve, reject) => {
        this.$refs["timezoneSetForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        });
      })
      console.log(a)
      return a
    },
    // 传参处理
    contentSetFormData(property){
      // console.log(this.contentSetForm[property])
      if(property=='showUserName'){
        this.$emit("contentSetFormData", property,this.contentSetForm[property]?1:0);
      }else if(property=='SingContent'){
        this.$emit("contentSetFormData", property,this.SingContent);
      }else if(property=='attachmentVos'){
        this.$emit("contentSetFormData", property,this.attachmentVos);
      }else if(property=='tempUrlShow'){
        this.$emit("contentSetFormData", property,this.tempUrlShow);
      }else if(property=='sendModel'){//发送时间
        this.$emit('contentSetFormData',property,this.contentSetForm[property])
        this.$emit('contentSetFormData','scheduleSendTimezone',this.contentSetForm.scheduleSendTimezone)
        this.$emit('contentSetFormData','scheduleSendTimezoneTime',this.contentSetForm.scheduleSendTimezoneTime)
        this.$emit('contentSetFormData','scheduleSendTime',this.contentSetForm.scheduleSendTime)
      }else{
        this.$emit("contentSetFormData", property,this.contentSetForm[property]);
      }
      
    },
    // AI窗口处理
    AIbtnShowFun(type){
      // console.log(type)
      if(type=='second'){
        this.$refs.AIAbility.activeName='second'
      }else{
        this.$refs.AIAbility.activeName='first'
      }
      this.$refs.AIAbility.drawer=true
      this.AIdrawer(true)
    },
    // AI窗口展示底部按钮要处理
    AIdrawer(val){
      this.$emit('AIdrawer',val)
    },
    querySearch(queryString, cb) {
      var restaurants = this.edm_purpose;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(this.contentSetForm.name)
      this.$refs["contentSetForm"].validateField('name');
      this.contentSetFormData('name')
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    // // 根据类型批量获取字典数据
    async getInitDictByType(codeMap,replyEmail){
      this.edm_purpose=[]
      let temp=  {
            value: '',
            label: ''
          }
      codeMap.edm_purpose.map(item=>{
        let temp=  {
            value: item.name,
            label: item.name
          }
        this.edm_purpose.push(temp)
      })
      // console.log(this.edm_purpose)
      if(!this.contentSetForm.replyEmail){
        this.contentSetForm.replyEmail=replyEmail
      }
    },
    // 选择收件人
    recipientDialog(){
      this.$refs.allRecipientListDialog.dialogVisible=true
      this.$refs.allRecipientListDialog.getQueryRecipient()
      this.$refs.allRecipientListDialog.getcontactIds(this.contactIds)
    },
    // 发送时间
    sendModelChange(){
      if (this.contentSetForm.sendModel == "1") {
        this.$refs.contentSetForm.fields.forEach(function (e) {
          if (e.prop === "sendModel") {
            e.resetField();
          }
        });
        this.dates = "";
        this.time = "";
        this.contentSetForm.scheduleSendTime=''
        this.contentSetForm.scheduleSendTimezoneTime=''
      }
      this.contentSetFormData('sendModel')
    },
    // 定时发送时的日期
    datesBlur () {
      this.timeDefault = false;
      // this.$emit("scheduleDates", this.dates);
      this.time = "";
      // if(this.time != ""&&this.dates!=''){
      //   let tempTime = this.dates + " " + this.time;
      //   console.log(tempTime)
      //   let date = new Date(tempTime);
      //   this.pushingSetForm.scheduleSendTime=date.getTime();
      //   this.contentSetFormData('sendModel')
      // }
    },
    // 定时发送时的日期时间
    datesTime () {
      if(this.time != ""&&this.dates!=''){
        let tempTime = this.dates + " " + this.time;
        let date = new Date(tempTime);
        this.localtime=date.getTime();
        this.localtimeBlur()
        // this.contentSetForm.scheduleSendTime=date.getTime();
        // this.contentSetFormData('sendModel')
      }
    },
    // 限制时间
    pickerTime () {
      // 先判断日期是否为同一天
      // var typeDates1 = handleFormatDate(new Date().getTime());
      // var typeDates2 = handleFormatDateHHmmss(new Date().getTime());
      // if (typeDates1 == this.dates) {
      //   this.pickerOptionsTime.selectableRange = typeDates2 + " - 23:59:59";
      // } else {
      //   this.pickerOptionsTime.selectableRange = "00:00:00 - 23:59:59";
      // }
    },
    // 时区
    scheduleSendTimezoneChange(){
      // this.localtime=''
      // this.time=''
      // this.dates=''
      // this.timeresY=''
      // this.timezoneSetForm.scheduleSendTimezoneTime=''
      this.contentSetForm.scheduleSendTimezone=this.timezoneSetForm.scheduleSendTimezone
      this.localtimeBlur(true)
    },
    localtimeBlur(flag){
      if(this.contentSetForm.scheduleSendTimezone){
        let dayObj= dayjsFormat(this.localtime,this.contentSetForm.scheduleSendTimezone)
        this.timeresY=dayObj.timeresY
        if(dayObj.sendtimestamp>dayObj.localTimeTamp){
          this.timezoneSetForm.scheduleSendTimezoneTime=this.localtime
          this.contentSetForm.scheduleSendTime=dayObj.sendtimestamp
          this.contentSetForm.scheduleSendTimezoneTime= this.timezoneSetForm.scheduleSendTimezoneTime
          this.contentSetFormData('sendModel')
        }else{
          this.time=''
          this.dates=''
          this.timezoneSetForm.scheduleSendTimezoneTime=''
          this.contentSetForm.scheduleSendTimezoneTime= this.timezoneSetForm.scheduleSendTimezoneTime
          if(!flag){
            this.$message.error('发送时间不能小于当前系统时间')
          }
        }
        
      }
    },
    // 选中的发送人员
    determine(val){
      this.contactIds=val
      this.contentSetForm.contactIds=[]
      this.contactIds.map(item=>{
        this.contentSetForm.contactIds.push(item.id)
      })
      this.$refs["contentSetForm"].validateField('contactIds');
      this.contentSetFormData('contactIds')
    },
    // 删除选中的收件人
    handleClosetag(tag) {
      // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.contactIds.forEach((value,index,array)=>{
        if(value.id == tag.id){
          array.splice(index,1)
        }
      })
      this.contentSetForm.contactIds=[]
      this.contactIds.map(item=>{
        this.contentSetForm.contactIds.push(item.id)
      })
      this.$refs["contentSetForm"].validateField('contactIds');
      this.contentSetFormData('contactIds')
    },
  },

}
</script>
<style lang="scss" scoped>
  .signListdivAll{
    height: 150px;
    overflow: auto;
  }
    /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
.contentSet{
  margin-top: 16px;
  .contentSetTitle{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181A;
    margin-left: 20px;
    margin-bottom: 18px
  }
 ::v-deep .contentSetForm{
  margin-left: 36px;
  .borderB{
    border-bottom: 1px solid #EDF0F4;
    width: 676px;
    .borderBdiv{
      color: #16181aff;
      // padding-left: 15px;
    }
  }
  .marginB{
    margin-bottom: 0px;
  }
  .el-input{
    width: 480px;
  }
  .el-form-item{
    width: 676px;
    padding-bottom: 8px;
  }

  .el-form-item__error{
    padding-top: 12px;
  }
  .el-form-item__label:before{
    position: absolute;
    left: 28px;
  }
    .el-form-item__label{
      color: #4F5D78;
      font-size: 14px;
      font-face: SourceHanSansCN;
      font-weight: 400;
      text-align: left;
    }
    .el-radio__label{
      font-size: 14px;
    }
    .el-checkbox__label{
      font-size: 14px;
    }
    .el-autocomplete{
      width: 100%;
    }
    .el-input--small .el-input__inner{
      width: 480px;
      font-size: 14px;
      border: none;
      color: #16181aff;
      padding-left: 0px
    }
    .replyEmail{
      .datesTime{
        margin-left: 4px;
      }
      .el-input{
        width: auto;

      }
      .el-input--small .el-input__inner{
        width: 220px;
        font-size: 14px;
        border: 1px solid #DCDFE6;
        padding-left: 16px;
      }

    }
    // .sendModel{
    //   .el-input--small .el-input__inner{
    //     width: 480px;
    //     font-size: 12px;
    //     border: 1px solid #DCDFE6;
    //   }
    // }

    .sys-note-index{
      width: 640px;
      // .tox-tinymce{
      //   height: 337px !important;
      // }
      // .tox .tox-edit-area{
      //   height: 238px;
      // }
    }
  }
}
::v-deep .signForm{
  .el-input--small .el-input__inner{
    width: 100% !important;
    font-size: 12px;
  }
  .el-form-item{
    width: auto !important;
  }
  .el-form-item__label{
    color: #4f5d78ff;
    font-size: 12px;
    font-face: SourceHanSansCN;
    font-weight: 400;
  }
  .el-input{
    width: 100% !important;
  }
  .sys-note-index{
    width: 100% !important;
    // height: 254px !important;
  }
  // .tox-tinymce{
  //   height: 254px !important;
  // }
}
.signListdiv{
  line-height: 36px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
  border-bottom: 1px solid #EDF0F4;
  margin-bottom: 2px;
  .itemSign{
    cursor: pointer;
  }
}
.unsubscribe{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #16181A;
  // line-height: 30px;
}
::v-deep .SingContent {
  line-height: 18px;
  border: 1px solid #eeeeee;
  padding: 10px;
  // margin-top: 4px;
  width: 622px;
  overflow-x: auto;
  div {
    margin-bottom: 5px;
  }
  div,
  span,
  object,
  li,
  ul,
  img iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  pre,
  a,
  em,
  img,
  strong,
  sub,
  sup,
  b,
  i,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  menu,
  nav,
  output,
  ruby,
  section,
  abstractDesc,
  time,
  mark,
  audio,
  video,
  input,
  textarea,
  select,
  button,
  meter,
  progress {
    margin: revert;
  }
  a {
    color: rgb(0, 0, 238) !important;
  }
  img {
    // width: 100%;
  }
}
.title-ps{
  font-size: 12px;
  color: #ffac2f;
  line-height: 18px;
  // margin-bottom: 18px;
}
.emailTitle{
  display: flex;
  width:640px ;
  ::v-deep .emailTitleInput{
    .el-input--small .el-input__inner{
      width: 480px !important;
      padding-left: 0px;
    }
  }
  .emailTitleAI{
    color: #3025BD !important;
    cursor: pointer;
    margin-left: 2px;
    font-size: 14px;
  }
}
.recipientTitle{
  display: flex;
  width:640px ;
  ::v-deep .recipientInput{
    // height: 68px;
    // border: 1px solid #cfd5df;
    width: 480px !important;
    border-radius: 2px;
    // padding-left: 15px;
    max-height: 140px;
    overflow: auto;
    .tagList {
      margin-right: 8px;
      margin-bottom: 8px;
      color: #16181aff;
    }
    .el-input--small .el-input__inner{
      width: 480px !important;
    }
  }
  .recipientList{
    color: #066EB7 !important;
    cursor: pointer;
    margin-left: 43px;
    align-self: center;
    font-size: 14px;
  }
}
::v-deep .TimezoneSetForm{
  background: #F5F7FA;
  padding: 20px;

  .localtime{
    color:#066EB7 ;
  }
  .el-form-item__label:before{
    position: inherit !important;

  }
  .scheduleSendTimezone{
      width: 300px !important;
      .el-input__inner{
        width: 300px !important;
      }
    }
  .scheduleSendTimezoneTime{

    .date{
      width:176px !important;
      .el-input__inner{
        width: 176px !important;
        padding-left: 30px !important;
      }
    }
    .datesTime {
      width: 120px !important;
      .el-input__inner{
        width: 120px !important;
      }
    }
  }
}
::v-deep .common-upload{
  .el-upload{
    .el-button--small{
      font-size: 14px !important;
    }
  }
}
.addSignReference{
  font-size: 14px
}
::v-deep .common-upload{
  margin-bottom: 0px;
}
</style>
<style>
.popoverSign{
  /* min-width: 80px; */
  padding-bottom: 2px;


}

.signDialog{
  width: 528px !important;
}

</style>